import { createContext, useContext } from 'react';

import type { OrganizationDetail, Organization } from '@rtkwlf/eloc';

import { env } from '@packages/utils/env';

type OrganizationContextType = {
  /**
   * Current selected Organization
   */
  selectedOrganization: OrganizationDetail;

  /**
   * Select Organization
   */
  selectOrganization: (org: Organization, callBack?: () => void) => void;
};

export const OrganizationContext =
  createContext<OrganizationContextType | null>(null);

export const useOrganizationContext = (): OrganizationContextType => {
  const ctx = useContext(OrganizationContext);

  if (ctx === null) {
    throw new Error(
      'useOrganizationContext hook must be used within an OrganizationContext.Provider; ensure your node is wrapped in one.',
    );
  }

  if (env.VITE_RENDALL_BASE_PATH) {
    ctx.selectedOrganization.rendallURL = env.VITE_RENDALL_BASE_PATH;
  }

  return ctx;
};

/** @deprecated please use useOrganizationContext().selectedOrganization */
export const useSelectedOrganization = () => {
  const context = useOrganizationContext();
  return context.selectedOrganization;
};
